import {Injectable} from '@angular/core';
import {lastValueFrom, Observable, shareReplay} from "rxjs";
import {ApiService} from "../service/api.service";

@Injectable({
  providedIn: 'root',
})
export class Principal {

  private _user$?: Observable<User>;

  constructor(private readonly api: ApiService) {
  }

  private get user$(): Observable<User> {
    this._user$ ??= this.api.get<User>("/api/user").pipe(shareReplay({
      bufferSize: 1,
      refCount: false
    }));
    return this._user$;
  }

  getUser(): Promise<User> {

    return lastValueFrom(this.user$);
  }

  async getName(): Promise<string> {

    return lastValueFrom(this.user$).then(user => user.name);
  }

  async getEmail(): Promise<string> {

    return lastValueFrom(this.user$).then(user => user.email);
  }

  getAuthorities(): Promise<string[]> {

    return lastValueFrom(this.user$).then(user => user.authorities);
  }

  hasAnyAuthority(authorities: string[]): Promise<boolean> {

    return this.getAuthorities().then(userAuthorities => this._containsAny(userAuthorities, authorities));
  }

  _containsAny(authorities: string[], testAuthorities: string[]): boolean {

    for (const element of testAuthorities) {
      if (authorities.includes(element)) {
        return true;
      }
    }

    return false;
  }
}

export interface User {
  name: string;
  email: string;
  authorities: string[];
}
